import { images } from '@gitbook/doc-core';
import type { InlineProps } from '@gitbook/slate-react';
import { Image } from '@gitbook/spine-react';

/**
 * Basic renderer for an inline image.
 */
export function BasicInlineImage(props: InlineProps): React.ReactElement {
    const { node } = props;

    const ref = node.data.get('ref');
    const altText = images.getImageAltText(node);
    const { url } = ref;

    return (
        <div contentEditable={false} className="inline-flex">
            <Image src={url} className="max-w-76" alt={altText} />
        </div>
    );
}
